import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  images: string[];
  alt: string;
}

export default function ProductGallery({ images, alt }: Props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const current = images[active] || images[0];

  return (
    <div>
      {/* Main image */}
      <div className="relative overflow-hidden rounded-lg border border-neutral-200 bg-neutral-100">
        <img
          src={current}
          alt={alt}
          title={alt}
          className="h-[320px] w-full object-cover object-top md:h-[440px]"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-brand-dark/80 px-2.5 py-1 text-[11px] font-medium text-white backdrop-blur">
          <i className="ri-image-line"></i>
          {t("detail.photos")}
        </span>
      </div>

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="mt-3 grid grid-cols-3 gap-3">
          {images.map((src, i) => (
            <button
              key={src}
              type="button"
              onClick={() => setActive(i)}
              className={`relative overflow-hidden rounded-md border bg-neutral-100 transition ${
                i === active ? "border-brand-gold ring-2 ring-brand-gold/30" : "border-neutral-200 hover:border-neutral-300"
              }`}
            >
              <img
                src={src}
                alt={`${alt} ${i + 1}`}
                className="h-20 w-full object-cover object-top md:h-24"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}